module.exports = __webpack_public_path__ + "img/location-3.57e7dfbe.jpg";